var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetAllocationKsLifecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 53.2144C28.5 51.5575 29.8431 50.2144 31.5 50.2144H44.4999C46.1568 50.2144 47.4999 51.5575 47.4999 53.2144V73C47.4999 74.6568 46.1568 76 44.4999 76H31.5C29.8431 76 28.5 74.6568 28.5 73V53.2144Z",
    fill: "#BCEECD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 40.9998C57 39.3429 58.3431 37.9998 60 37.9998H72.9999C74.6568 37.9998 75.9999 39.3429 75.9999 40.9998V72.9996C75.9999 74.6565 74.6568 75.9996 72.9999 75.9996H60C58.3431 75.9996 57 74.6565 57 72.9996V40.9998Z",
    fill: "#BCEECD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 65.4282C0 63.7714 1.34315 62.4282 3 62.4282H15.9999C17.6568 62.4282 18.9999 63.7714 18.9999 65.4282V72.9996C18.9999 74.6565 17.6568 75.9996 15.9999 75.9996H3C1.34315 75.9996 0 74.6565 0 72.9996V65.4282Z",
    fill: "#BCEECD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 3C28.5 1.34314 29.8431 0 31.5 0H44.4999C46.1568 0 47.4999 1.34315 47.4999 3V22.7856C47.4999 24.4425 46.1568 25.7856 44.4999 25.7856H31.5C29.8431 25.7856 28.5 24.4425 28.5 22.7856V3Z",
    fill: "#1FBB55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57 3C57 1.34315 58.3431 0 60 0H72.9999C74.6568 0 75.9999 1.34315 75.9999 3V10.5714C75.9999 12.2282 74.6568 13.5714 72.9999 13.5714H60C58.3431 13.5714 57 12.2282 57 10.5714V3Z",
    fill: "#1FBB55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34314 1.34315 0 3 0H15.9999C17.6568 0 18.9999 1.34315 18.9999 3V34.9999C18.9999 36.6567 17.6568 37.9999 15.9999 37.9999H3C1.34315 37.9999 0 36.6567 0 34.9999V3Z",
    fill: "#1FBB55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 28.7854C28.5 27.1285 29.8431 25.7854 31.5 25.7854H44.4999C46.1568 25.7854 47.4999 27.1285 47.4999 28.7854V47.2139C47.4999 48.8707 46.1568 50.2139 44.4999 50.2139H31.5C29.8431 50.2139 28.5 48.8707 28.5 47.2139V28.7854Z",
    fill: "#64D68B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57 16.5715C57 14.9147 58.3431 13.5715 60 13.5715H72.9999C74.6568 13.5715 75.9999 14.9147 75.9999 16.5715V35C75.9999 36.6569 74.6568 38 72.9999 38H60C58.3431 38 57 36.6569 57 35V16.5715Z",
    fill: "#64D68B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.9998C0 39.3429 1.34315 37.9998 3 37.9998H15.9999C17.6568 37.9998 18.9999 39.3429 18.9999 40.9998V59.4282C18.9999 61.0851 17.6568 62.4282 15.9999 62.4282H3C1.34315 62.4282 0 61.0851 0 59.4282V40.9998Z",
    fill: "#64D68B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetAllocationKsLifecycle);
export default __webpack_public_path__ + "static/media/asset-allocation-ks-lifecycle.f99f907842401940bcc475ae2c50fdac.svg";
export { ForwardRef as ReactComponent };